import type { ReactNode } from "react";
import { Header } from "../components/organisms/Header";
import { SideMenu } from "../components/organisms/SideMenu";

type AppLayoutProps = {
  children: ReactNode;
};

export const AppLayout = ({ children }: AppLayoutProps) => (
  <div className="flex h-screen overflow-hidden bg-gray-50">
    <aside className="hidden md:flex">
      <SideMenu />
    </aside>
    <div className="flex flex-1 flex-col overflow-hidden">
      <Header />
      <main className="flex-1 overflow-y-auto">
        <div className="px-6 py-8">{children}</div>
      </main>
    </div>
  </div>
);
